export default "__VITE_ASSET__D1bMTE1e__"